export interface SelectableAtsIntegration {
  deleted?: boolean;
  is_default?: boolean;
}

/**
 * Return the org's explicit active default integration.
 *
 * A single active integration remains a safe fallback for older cached or
 * mocked payloads that predate `is_default`. Multiple active integrations
 * without an explicit default are ambiguous and must not fall back to row
 * order.
 */
export function getDefaultAtsIntegration<T extends SelectableAtsIntegration>(
  integrations: T[]
): T | undefined {
  const activeIntegrations = integrations.filter(
    (integration) => !integration.deleted
  );
  const defaultIntegration = activeIntegrations.find(
    (integration) => integration.is_default
  );

  if (defaultIntegration) {
    return defaultIntegration;
  }

  const [onlyIntegration, ...otherIntegrations] = activeIntegrations;
  const legacyIntegration =
    onlyIntegration &&
    otherIntegrations.length === 0 &&
    onlyIntegration.is_default === undefined
      ? onlyIntegration
      : undefined;

  return legacyIntegration;
}
